import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/client.ts");
;
import(/* webpackMode: "eager" */ "/app/src/lib/translate/i18n/i18n-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InitialClient"] */ "/app/src/modules/components/commons/Inittial/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/components/Home/ComingSoon.tsx");
